<template>
  <div style="padding: 20px">
    <!-- Loader -->
    <v-overlay :value="overlay" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" class="py-0">
        <v-hover>
          <template v-slot="{ hover }">
            <v-card :elevation="hover ? 24 : 2">
              <!-- Bottone di creazione commessa singola -->
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                  Commessa
                  <v-icon color="white">mdi-file-cog-outline</v-icon>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <Button
                  classe_bottone="mr-5"
                  colore_icona="primary"
                  idForm="COMMESSA"
                  idOggetto="CREA_COMMESSA"
                  mdi_icona="mdi-plus"
                  testo_tooltip="Nuova Commessa"
                  v-on:buttonClick="GoToCommessa"
                />
                <Button
                  classe_bottone="mr-5"
                  colore_icona="primary"
                  idForm="COMMESSA"
                  idOggetto="CREA_COMMESSA_MULTIPLA"
                  mdi_icona="mdi-expand-all"
                  testo_tooltip="Nuova Commessa Multipla"
                  v-on:buttonClick="GoToCommessaMultipla()"
                />

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      @click="openImpostazioni"
                      small
                    >
                      <v-icon color="primary">mdi-cog</v-icon>
                    </v-btn>
                  </template>
                  <span>Impostazioni Commesse</span>
                </v-tooltip>

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="
                        !(cambia_stato_sel === true && items.length > 0)
                      "
                      v-on="on"
                      v-bind="attrs"
                      v-on:keydown.enter.prevent="makePicking"
                      @click="makePicking"
                      small
                      class="mr-5"
                    >
                      <v-icon color="primary">mdi-format-list-checks</v-icon>
                    </v-btn>
                  </template>
                  <span>Crea Picking List</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="!(cambia_stato_sel === true)"
                      v-on="on"
                      v-bind="attrs"
                      v-on:keydown.enter.prevent="makePicking"
                      @click="selectAll"
                      small
                    >
                      <v-icon color="primary">{{
                        selectAllBool ? "mdi-check" : "mdi-cancel"
                      }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    selectAllBool ? "Seleziona Tutti" : "Seleziona Nessuno"
                  }}</span>
                </v-tooltip>

                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="
                        !(cambia_stato_sel === true && items.length > 0)
                      "
                      v-on="on"
                      small
                      @click="duplicazioneMassiva()"
                    >
                      <v-icon color="primary">mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Duplica Commessa</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <!-- Bottone di cambiamento stato commessa -->
                <Button
                  classe_bottone="mr-5"
                  colore_icona="primary"
                  idForm="COMMESSA"
                  idOggetto="GESTIONE_COMMESSA_STATO"
                  mdi_icona="mdi-order-bool-ascending-variant"
                  testo_tooltip="Gestione Stato"
                  v-on:buttonClick="
                    items.length > 0
                      ? (cambia_stato_sel = !cambia_stato_sel)
                      : (cambia_stato_sel = false)
                  "
                />
                <!-- Bottone di invio modifiche dello stato commessa -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="
                        !(cambia_stato_sel === true && items.length > 0)
                      "
                      v-on="on"
                      v-bind="attrs"
                      small
                      @click="clickModificaStatoCommessa"
                      class="mr-5"
                    >
                      <v-icon color="primary">mdi-check-all</v-icon>
                    </v-btn>
                  </template>
                  <span>Invia Modifiche di Stato</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      @click="gotoDashboard"
                      small
                    >
                      <v-icon color="error">mdi-keyboard-backspace</v-icon>
                    </v-btn>
                  </template>
                  <span>Vai alla Dashboard</span>
                </v-tooltip>
              </v-toolbar>
              <v-card-subtitle>
                <v-row justify="center">
                  <v-col class="py-0" cols="3">
                    <!-- Filtro dalla data -->
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="289"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="formatDate"
                          label="Dalla Data"
                          placeholder="Dalla Data"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="data_da"
                        @input="menu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="py-0" cols="3">
                    <!-- Filtro entro la data -->
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="289"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="formatDaAa"
                          label="Entro la Data"
                          placeholder="Entro la Data"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="data_a"
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="py-0" cols="3">
                    <!-- Filtro stato commessa -->
                    <v-autocomplete
                      v-on:keydown.enter.prevent="getCommessa"
                      v-model="des_stato"
                      :items="des_stato_list"
                      item-text="des"
                      label="Filtra per Stato Commessa"
                      placeholder="Stato Commessa"
                      required
                      item-value="val-txt"
                      @change="changeFilter"
                    ></v-autocomplete>
                  </v-col>

                  <!-- Filtro di ricerca stringa -->
                  <v-col class="py-0" cols="3" justify="center">
                    <v-text-field
                      v-model="search"
                      label="Cerca nella Tabella"
                      single-line
                      hide-details
                      @keydown.enter="getCommessaFromButton"
                    >
                      <!--  -->
                      <template v-slot:append>
                        <v-icon
                          @click="
                            search = '';
                            search_confirmed = '';
                            items_displayed = [];
                          "
                          color="error"
                          v-if="search != null && search != ''"
                        >
                          mdi-close
                        </v-icon>
                      </template>

                      <!-- Bottone di ricerca -->
                      <template v-slot:append-outer>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-on="on"
                              v-bind="attrs"
                              @click="getCommessaFromButton"
                              small
                            >
                              <v-icon color="primary">mdi-magnify</v-icon>
                            </v-btn>
                          </template>
                          <span>Lista Commesse</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="items.length > 0" justify="center">
                  <v-col class="py-0" cols="3" v-if="cambia_stato_sel === true">
                    <!-- Select di modifica dello stato -->
                    <v-autocomplete
                      outlined
                      v-model="stato_sel"
                      :items="des_stato_list"
                      item-text="des"
                      label="Cambia in Stato..."
                      placeholder="Stato Commessa"
                      required
                      style="border-radius: 0px"
                      item-value="id_tabella"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-subtitle>
              <v-card-text>
                <v-data-table
                  :headers="headers.filter((h) => h.visible == 1)"
                  :items="items"
                  :search="search_confirmed"
                  fixed-header
                  height="55vh"
                >
                  <template v-slot:[`item.data_picking`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          :color="
                            item.data_picking != null ? 'success' : 'error'
                          "
                          v-on="on"
                        >
                          {{
                            item.data_picking != null
                              ? "mdi-check"
                              : "mdi-cancel"
                          }}
                        </v-icon>
                      </template>
                      <span>{{
                        item.data_picking != null
                          ? item.data_picking
                          : "Picking non creato"
                      }}</span>
                    </v-tooltip>
                  </template>

                  <template v-slot:[`item.des_stato`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          :color="statusIcons[item.des_stato].color"
                          v-on="on"
                        >
                          {{ statusIcons[item.des_stato].icon }}
                        </v-icon>
                      </template>
                      <span>{{ item.des_stato }}</span>
                    </v-tooltip>
                  </template>
                  <!-- Colonna per la selezione di stato -->
                  <template
                    v-slot:[`item.edit_stato`]="{ item }"
                    v-if="cambia_stato_sel === true"
                  >
                    <v-checkbox v-model="item.edit_stato"></v-checkbox>
                  </template>
                  <!-- Colonna per l'azione di modifica -->
                  <template v-slot:[`item.edit`]="{ item }">
                    <Button
                      v-if="cambia_stato_sel === false"
                      classe_bottone="ml-2"
                      colore_icona="primary"
                      idForm="COMMESSA"
                      idOggetto="MODIFICA_COMMESSA"
                      mdi_icona="mdi-pencil"
                      testo_tooltip="Dettaglio Commessa"
                      v-on:buttonClick="handleClick(item)"
                    />
                  </template>
                  <!-- Colonna per l'azione di subentro -->
                  <template v-slot:[`item.personale`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small @click="clickPersonale(item)">
                          <v-icon color="primary">mdi-account</v-icon>
                        </v-btn>
                      </template>
                      <span>Personale</span>
                    </v-tooltip>
                  </template>

                  <!-- Colonna per l'associazione di idearicamo -->
                  <template v-slot:[`item.associa_modelli`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          small
                          @click="clickDialogAssociaModello(item)"
                        >
                          <v-icon color="primary">mdi-human-edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Associa Modello</span>
                    </v-tooltip>
                  </template>

                  <!-- Colonna per il report -->
                  <template v-slot:[`item.report`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          small
                          @click="clickVisualizzaReport(item)"
                        >
                          <v-icon color="error">mdi-file-pdf-box</v-icon>
                        </v-btn>
                      </template>
                      <span>Visualizza Report</span>
                    </v-tooltip>
                  </template>

                  <!-- Colonna di duplicazione -->
                  <template v-slot:[`item.duplica`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small @click="duplicaCommessa(item)">
                          <v-icon color="primary">mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>Duplica Commessa</span>
                    </v-tooltip>
                  </template>

                  <!-- Colonna di duplicazione semplice -->
                  <template v-slot:[`item.duplicazione_semplice`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small @click="clickDuplica(item)">
                          <v-icon color="primary">mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>Duplica Commessa</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.allegati`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small @click="clickAllegati(item)">
                          <v-icon color="primary">mdi-paperclip</v-icon>
                        </v-btn>
                      </template>
                      <span>Allegati</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.graph`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small @click="OpenGraph(item)">
                          <v-icon color="primary">mdi-chart-bar</v-icon>
                        </v-btn>
                      </template>
                      <span>Graph</span>
                    </v-tooltip>
                  </template>
                  <!-- Colonna per l'azione di analisi -->
                  <template v-slot:[`item.analisi`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          small
                          @click="analisiArticolo(item.id_commessa)"
                        >
                          <v-icon color="primary">mdi-abacus</v-icon>
                        </v-btn>
                      </template>
                      <span>Analisi</span>
                    </v-tooltip>
                  </template>
                  <!--<template v-slot:[`item.datacommessa`]="{ item }">
                    {{
                      item.datacommessa != null
                        ? `${item.datacommessa.substring(
                            8,
                            10
                          )}/${item.datacommessa.substring(
                            5,
                            7
                          )}/${item.datacommessa.substring(0, 4)}`
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.dataconsegna`]="{ item }">
                    {{
                      item.datacommessa != null
                        ? `${item.dataconsegna.substring(
                            8,
                            10
                          )}/${item.dataconsegna.substring(
                            5,
                            7
                          )}/${item.dataconsegna.substring(0, 4)}`
                        : ""
                    }}
                  </template>-->
                </v-data-table>
              </v-card-text>
            </v-card>
          </template>
        </v-hover>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :color="snackbar_background" :timeout="3000">
      <span
        :style="{
          fontSize: snackbar_font_size,
          lineHeight: snackbar_font_size,
        }"
      >
        {{ snackbar_text }}
      </span>
    </v-snackbar>

    <v-dialog v-model="impostazioniDialog" width="90vw" scrollable>
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Impostazioni Commesse
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="addColumn" small :disabled="tab != 1">
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Nuova Colonna</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="saveImpostazioni" small class="ml-5">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="impostazioniDialog = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-tabs v-model="tab">
          <v-tab key="general">Generale</v-tab>
          <v-tab key="columns">Colonne</v-tab>
        </v-tabs>
        <v-card-text>
          <v-tabs-items v-model="tab">
            <v-tab-item key="general">
              <v-col cols="12">
                <v-row>
                  <v-col cols="6">
                    <v-select
                      :items="mesi_passato"
                      label="Mesi nel Passato"
                      v-model="mesi_p"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      :items="mesi_futuro"
                      label="Mesi nel Futuro"
                      v-model="mesi_f"
                    >
                    </v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6">
                    <v-select
                      :items="tipi_avanzamento"
                      append-outer-icon="mdi-help-circle"
                      label="Tipo Avanzamento"
                      item-text="des"
                      item-value="val_int"
                      v-model="tipo_avanzamento"
                      @click:append-outer="informazioniDialog = true"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      :items="tipi_ordinamento_date"
                      label="Ordinamento Date Consegna"
                      item-text="des"
                      item-value="value"
                      v-model="tipo_ordinamento_date"
                    >
                    </v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6">
                    <v-select
                      :items="des_stato_list"
                      item-text="des"
                      item-value="id_tabella"
                      label="Stato Default"
                      v-model="stato_def"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      :items="isPickingListItems"
                      label="Picking List Default"
                      v-model="is_picking"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="dashboard_sel"
                      label="Dashboard Graph"
                      item-value="id_elemento"
                      item-text="descrizione"
                      dense
                      :items="dashboards"
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-tab-item>
            <v-tab-item key="columns">
              <v-data-table
                :headers="headers_impostazioni"
                :items="items_impostazioni"
              >
                <template v-slot:[`item.text`]="{ item }">
                  <v-text-field v-model="item.text"></v-text-field>
                </template>
                <template v-slot:[`item.value`]="{ item }">
                  <v-text-field v-model="item.value"></v-text-field>
                </template>
                <template v-slot:[`item.fields`]="{ item }">
                  <v-text-field v-model="item.fields"></v-text-field>
                </template>
                <template v-slot:[`item.join_fields`]="{ item }">
                  <v-text-field v-model="item.join_fields"></v-text-field>
                </template>
                <template v-slot:[`item.ordine`]="{ item }">
                  <v-text-field v-model="item.ordine"></v-text-field>
                </template>
                <template v-slot:[`item.visible`]="{ item }">
                  <v-text-field v-model="item.visible"></v-text-field>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="informazioniDialog" width="500">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Informazioni Tipi Avanzamento</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="informazioniDialog = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-col cols="12">
            <v-row>
              1) placing list: quando viene avanzata una quantità (sia da
              produzione sia da contenitore) il sistema crea: una movimento
              positivo (+ N pezzi) all'interno del magazzino WIP. Una volta ogni
              X ore (X è un parametro definibile dall'utente) il sistema crea
              una pacling list con gli articoli presenti nel WIP da portare nel
              magazzino STOCK. Mediante la placing list l'utente potrà collocare
              la merce nella singola ubicazione di magazzino
            </v-row>
            <v-row>
              2) contenitore a magazzino: quando viene avanzata una quantità
              mediante DICHIARAZIONE CONTENITORE il sistema crea un movimento di
              magazzino positivo (+N pezzi) all'interno del magazzino WIP
            </v-row>
            <v-row>
              3) contenitore a produzione: quando viene avanzata una quantità
              mediante DICHIARAZIONE PRODUZIONE il sistema crea un movimento di
              magazzino positivo (+N pezzi) all'interno del magazzino WIP
            </v-row>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Mini dialog per indicare i work order attivi -->
    <v-dialog v-model="dialog_impegni" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-row>
            <v-col align="center" cols="4"></v-col>
            <v-col align="center" cols="4">
              <v-btn
                @click="
                  modificaStatoCommessa();
                  dialog_impegni = false;
                "
                small
              >
                <span style="color: rgb(76, 175, 80)"
                  >Conferma Irreversibile</span
                >
              </v-btn>
            </v-col>
            <v-col align="right" cols="4">
              <v-btn @click="dialog_impegni = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-card-text class="pt-3">
          <div style="display: inline-block; max-width: 500px">
            <span style="font-size: 15px">
              Risultano esserci dei Work Order attivi per le commesse
              selezionate elencate di seguito. Confermando di voler modificare
              il loro stato, i Work Order associati verranno forzati a fermarsi.
              Si intende procedere?
            </span>
          </div>
          <v-data-table
            :headers="headers_commesse_aperte"
            hide-default-footer
            :items="items_commesse_aperte"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog Fasi e Personale -->
    <v-dialog v-model="dialog_personale_fasi" width="unset">
      <!-- Loader -->
      <v-overlay :value="overlay" style="z-index: 10">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-toolbar dark color="indigo" dense>
          <v-toolbar-title>Ciclo Commessa Produzione</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="setPersonaleCommessa"
                v-on="on"
                light
                v-bind="attrs"
                small
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="closeDialogCicli"
                v-on="on"
                light
                v-bind="attrs"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="pt-3">
          <v-data-table :headers="headers_ciclo" :items="ciclo_lista">
            <template v-slot:[`item.personale_new`]="{ item }">
              <v-select
                v-model="item.personale_new"
                :items="personale_list"
                :item-text="
                  (item) =>
                    item.cognome != null
                      ? item.cognome + ' ' + item.nome
                      : item.nome
                "
                item-value="id_utente"
                return-object
                label="Seleziona il nominativo"
                multiple
                style="width: 300px"
              ></v-select>
            </template>

            <!-- Pulsante della registrazione squadra -->
            <template v-slot:[`item.selezione_squadra`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-5"
                    @click="selezionaSquadra(item)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary"> mdi-account-multiple </v-icon>
                  </v-btn>
                </template>
                <span>Seleziona Squadra</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di selezione squadra -->
    <v-dialog v-model="dialog_selezione_squadra" width="500">
      <!-- Loader -->
      <v-card>
        <v-toolbar dark color="indigo" dense>
          <v-toolbar-title>Selezione Squadra</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="confermaSelezioneSquadra"
                v-on="on"
                light
                v-bind="attrs"
                small
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_selezione_squadra = false"
                v-on="on"
                light
                v-bind="attrs"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="pt-3">
          <v-container fluid>
            <v-row dense>
              <v-col cols="4">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_sedi_squadra"
                  item-text="descrizione"
                  item-value="id_azienda_sede"
                  label="Sede"
                  v-model="sede_sel"
                ></v-autocomplete>
              </v-col>
              <!--<v-col cols="4">
                <v-autocomplete
                  dense
                  hide-details
                  :items="
                    items_reparti_squadra && items_reparti_squadra.length > 0
                      ? items_reparti_squadra.filter(
                          (e) => e.id_azienda_sede == sede_sel
                        )
                      : []
                  "
                  item-text="descrizione"
                  item-value="id_azienda_sede_reparto"
                  label="Reparto"
                  v-model="reparto_sel"
                ></v-autocomplete>
              </v-col>-->
              <v-col cols="4">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_squadre"
                  item-text="des"
                  item-value="id_squadra"
                  label="Squadra"
                  v-model="squadra_sel"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <template v-if="items_operatori_squadra.length == 0">
              <v-row dense>
                <v-col cols="12">
                  <!-- Card sostitutiva in mancanza di squadre -->
                  <v-card class="mt-5" style="border: 1px solid black">
                    <v-card-text>
                      <span style="font-size: 14px">
                        Selezionare una squadra
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row class="mt-5" dense>
                <v-col cols="12">
                  <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                      Operatori
                    </v-toolbar-title>
                  </v-toolbar>
                </v-col>
              </v-row>
              <!-- Elenco degli operatori -->
              <v-row
                dense
                v-for="(operatore, i) in items_operatori_squadra"
                :key="i"
              >
                <v-col cols="3">
                  <v-simple-checkbox
                    color="primary"
                    v-model="operatore.selezionato"
                  ></v-simple-checkbox>
                </v-col>
                <v-col cols="9" align="left">
                  {{ operatore.nome }} {{ operatore.cognome }}
                </v-col>
              </v-row>
            </template>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog scelta report -->
    <v-dialog v-model="dialog_scelta_report" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Scelta Report </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_scelta_report = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_report_selezionati"
                  :items="items_report_selezionati"
                >
                  <!-- Colonna di stampa del report -->
                  <template v-slot:[`item.stampa`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="clickStampaReport(item.id_riferimento)"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-printer </v-icon>
                        </v-btn>
                      </template>
                      <span>Stampa</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Overlay di caricamento del dialog di scelta dei report -->
      <v-overlay :value="overlay_scelta_report" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <!-- Dialog di conferma duplicazione -->
    <v-dialog v-model="dialog_conferma_duplicazione" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Duplicazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Sei sicuro di voler duplicare la commessa selezionata?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_duplicazione = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn
                  @click="
                    duplicaCommessa(commessa_sel, 'no_moduli');
                    dialog_conferma_duplicazione = false;
                  "
                  small
                >
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_associa_modelli" fullscreen>
      <v-card class="ma-0 pa-0" height="620" style="overflow-x: scroll">
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            :component="'imageprod'"
            ref="windowframe_idearicamo"
            :input_args="input_args_modelli"
            @chiudi="chiudiAssociaModelli"
            :key="key_windowframe"
          />
        </div>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="dialog_associa_modelli" width="800">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%; overflow: hidden">
          <WindowFrame
            class="ma-0 pa-0"
            :component="'imageprod'"
            ref="windowframe_idearicamo"
          />
        </div>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="dialog_analisi_articolo">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            :component="'analisigenerale'"
            :input_args="input_args"
            :key="key_analisi_generale"
            @click_chiudi="handleClickChiudiAnalisi"
          />
        </div>
      </v-card>
    </v-dialog>

    <v-dialog class="ma-0 pa-0" v-model="allegati_visible" width="1200px">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        width="calc(100vw - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            referrerpolicy="origin"
            @click_chiudi="allegati_visible = false"
            :component="'allegati'"
            ref="windowframe_allegati"
            :input_args="input_args_allegati"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog di visualizzazione del report PDF -->
    <v-dialog v-model="pdfdialog" width="800px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Report </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="mr-5"
                @click="pdfdialog = false"
                small
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pa-0">
          <iframe
            :src="selected_pdf"
            frameborder="0"
            style="display: inline-block; height: 80vh !important; width: 100%"
          >
          </iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di Graph -->
    <v-dialog v-model="graphDialog" width="80vw">
      <v-toolbar class="white--text" color="indigo" dense>
        <v-toolbar-title>Quick Graph</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="graphDialog = false"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-card height="80vh" style="overflow-y: scroll">
        <WindowFrame component="graph" :input_args="graphArgs" :key="graphKey">
        </WindowFrame>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import Button from "../../../components/TOOLS/FormComponentPermissions/Button.vue";
import * as moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  components: { Button, SnackbarQV, WindowFrame },
  data() {
    return {
      commessa_sel: null,
      graphDialog: false,
      graphKey: false,
      graphArgs: {
        evento_target: "load_dashboard",
        payload: {
          version: 0,
          dashboard: -1,
          params: [],
        },
      },
      dashboards: [],
      dashboard_sel: -1,
      allegati_visible: false,
      fase_sel: new Object(),
      input_args_allegati: {
        id_utente: localStorage.id,
        id_riferimento: -1,
        cod_riferimento: "commessa",
        pk_riferimento: "id_commessa",
      },
      items_impostazioni: [],
      tab: "general",
      input_args: {},
      key_analisi_generale: 0,
      commessa: null,
      stato_def: null,
      is_picking: null,
      informazioniDialog: false,
      tipo_avanzamento: null,
      tipo_ordinamento_date: 0,
      mesi_p: 0,
      mesi_f: 0,
      impostazioniDialog: false,
      selectAllBool: true,
      cambia_stato_sel: false,
      id_stato_aperto: null,
      stato_sel: null,
      personale_tmp: null,
      input_args_modelli: {
        from_commessa: true,
        id_commessa: null,
      },
      key_windowframe: 0,
      sede_sel: null,
      reparto_sel: null,
      selected_pdf: "",
      squadra_sel: null,

      // Overlay Variable
      overlay: false,
      overlay_scelta_report: false,

      // Modal
      dialog_associa_modelli: false,
      dialog_conferma_duplicazione: false,
      dialog_personale_fasi: false,
      dialog_selezione_squadra: false,
      dialog_analisi_articolo: false,
      pdfdialog: false,
      snackbar: false,
      snackbar_background: "",
      snackbar_color: "",
      snackbar_font_size: "",
      snackbar_text: "",
      snackbar_sfondo: "",
      show: true,
      search: "",
      search_confirmed: "",
      menu: false,
      menu1: false,
      data_da: "",
      data_a: "",
      id_commessa: 0,
      id_stato: 0,
      des_stato: "Aperta",
      dialog_impegni: false,
      dialog_scelta_report: false,

      // Array
      ciclo_lista: [],
      ciclo_lista_clone: [],
      isPickingListItems: ["Si", "No"],
      items_report_selezionati: new Array(),
      mesi_passato: [1, 3, 6, 9, 12, 24, 36],
      mesi_futuro: [1, 2, 3],
      personale_list: ["Prova 1", "Prova 2", "Prova 3"],
      tipi_avanzamento: [],
      tipi_ordinamento_date: [
        { des: "Nessun ordinamento", value: 0 },
        { des: "ASC", value: 1 },
        { des: "DESC", value: 2 },
      ],
      des_stato_list: [],
      headers: [],
      headers_impostazioni: [
        { text: "Testo", value: "text" },
        { text: "Valore", value: "value" },
        { text: "Campi", value: "fields" },
        { text: "Campi join", value: "join_fields" },
        { text: "Ordine", value: "ordine" },
        { text: "Visible", value: "visible" },
      ],
      headers_report_selezionati: [
        {
          text: "Stampa",
          value: "stampa",
          sortable: false,
          width: "150px",
        },
        {
          text: "Cod. Report",
          value: "cod_report",
          sortable: false,
        },
      ],
      statusIcons: {
        Creata: {
          icon: "mdi-new-box",
          color: "primary",
        },
        Aperta: {
          icon: "mdi-play-speed",
          color: "orange",
        },
        Chiusa: {
          icon: "mdi-check-circle",
          color: "success",
        },
        Sospesa: {
          icon: "mdi-pause-circle",
          color: "orange",
        },
        Annullata: {
          icon: "mdi-close-circle",
          color: "error",
        },
      },
      headers_commesse_aperte: [
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
        },
        {
          text: "Utente",
          sortable: false,
          value: "nominativo",
        },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Ora Start",
          sortable: false,
          value: "data_inizio",
        },
      ],
      headers_ciclo: [
        {
          text: "Cod. Fase",
          sortable: false,
          value: "cod_fase",
        },
        {
          text: "Fase Lavoro",
          sortable: false,
          value: "des",
        },
        {
          text: "Personale",
          sortable: false,
          value: "personale_new",
        },
        {
          text: "Selezione Squadra",
          sortable: false,
          value: "selezione_squadra",
        },
      ],
      items: [],
      items_displayed: [],
      items_commesse_aperte: new Array(),
      items_operatori_squadra: new Array(),
      items_squadre: new Array(),
      items_reparti_squadra: new Array(),
      items_sedi_squadra: new Array(),
    };
  },
  methods: {
    clickStampaReport(arg_id_report) {
      const parametri = new Array();

      for (let param in this.commessa_sel) {
        parametri.push({
          simbolo: "@" + param,
          valore: this.commessa_sel[param],
        });
      }

      let request = {
        controller: "global",
        method: "POST",
        richiesta: {
          action: "getreportpdf",
          token: localStorage.getItem("user_token"),
          id_report: arg_id_report,
          parametri: parametri,
        },
      };

      this.overlay = true;
      this.overlay_scelta_report = true;
      this.$store
        .dispatch("api6", request)
        .then((res) => {
          this.overlay = false;
          this.overlay_scelta_report = false;
          if (
            "tipo_messaggio" in res.data &&
            "query_messaggio" in res.data &&
            res.data.tipo_messaggio == 1
          ) {
            this.$refs.SnackbarQV.print("orange", res.data.query_messaggio);
          }
          const byteCharacters = atob(res.data.result);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: "application/pdf",
          });
          const blobUrl = URL.createObjectURL(blob);
          this.selected_pdf = blobUrl;
          this.pdfdialog = true;
        })
        .catch((err) => {
          this.overlay = false;
          this.overlay_scelta_report = false;
          if (
            "tipo_messaggio" in err.response.data &&
            "query_messaggio" in err.response.data &&
            err.response.data.tipo_messaggio == 2
          ) {
            this.$refs.SnackbarQV.print(
              "error",
              err.response.data.query_messaggio
            );
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
          console.error(err);
        });
    },
    clickVisualizzaReport(arg) {
      this.items_tipi_report.forEach((t) => {
        if (t.id_tabella == arg.tipo_commessa) {
          if (t.associazioni) {
            if (t.associazioni.length == 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                "Non ci sono report associati a questo tipo di commessa."
              );
            } else if (t.associazioni.length == 1) {
              this.commessa_sel = JSON.parse(JSON.stringify(arg));
              this.clickStampaReport(t.associazioni[0].id_riferimento);
            } else {
              this.commessa_sel = JSON.parse(JSON.stringify(arg));
              this.items_report_selezionati = t.associazioni;
              this.dialog_scelta_report = true;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Non ci sono report associati a questo tipo di commessa."
            );
          }
        }
      });
    },
    confirmSearch() {
      this.items_displayed = new Array();
      this.search_confirmed = this.search;
      this.filterList();
    },
    filterList() {
      this.items.forEach((i) => {
        let is_valid = false;
        this.headers.forEach((h) => {
          if (
            String(i[h.value])
              .toUpperCase()
              .includes(this.search.toUpperCase()) ||
            this.search == null ||
            this.search === ""
          ) {
            is_valid = true;
          }
        });

        if (is_valid) {
          this.items_displayed.push(i.id_commessa);
        }
      });
    },
    getAssociazioniTipiReport() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getassociazionitipireport",
          token: localStorage.getItem("user_token"),
          tipo: "COMMESSA_TIPO"
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (res.data.result.tipi) {
              this.items_tipi_report = new Array();

              // Ordino i tipi perché voglio che il "non assegnato" sia in cima.
              res.data.result.tipi.sort((a, b) =>
                a.id_tabella < b.id_tabella
                  ? -1
                  : a.id_tabella > b.id_tabella
                  ? 1
                  : 0
              );

              // Aggiusto il tipo "Non assegnato" e gli id_modulo delle sue relazioni.
              res.data.result.tipi.forEach((t) => {
                if (t.id_tabella == -99) {
                  t.id_tabella = null;
                  if (t.associazioni) {
                    t.associazioni.forEach((a) => {
                      a.id_modulo = null;
                    });
                  }
                }
              });

              this.items_tipi_report = res.data.result.tipi;
            }
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
          return false;
        });
    },
    async getCommessaFromButton() {
      await this.getCommessa();
      this.confirmSearch();
    },
    getStatiCommessa() {
      let stato_list = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "'commessa_stato','DATA_COMMESSA'",
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", stato_list)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            res.data.COMMESSA_STATO.forEach((e) => {
              if (e.val_int === 1) {
                this.id_stato_aperto = e.id_tabella;
              }
            });
            this.des_stato_list = res.data.COMMESSA_STATO
              ? res.data.COMMESSA_STATO
              : [];
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server nel caricamento degli stati della commessa."
            );
            return false;
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server nel caricamento degli stati della commessa."
          );
          return false;
        });
    },
    OpenGraph(item) {
      this.graphArgs.payload.dashboard = this.dashboard_sel;
      this.graphArgs.payload.params = [];
      this.graphArgs.payload.params.push({
        simbolo: "$id_commessa",
        valore: item.id_commessa,
      });
      this.graphKey = !this.graphKey;
      this.graphDialog = true;
    },
    async GetDashboard() {
      let request = {
        controller: "graph",
        method: "POST",
        richiesta: {
          action: "getdashboard",
          token: localStorage.getItem("user_token"),
        },
      };

      await this.$store
        .dispatch("api6", request)
        .then((res) => {
          this.dashboards = res.data.result;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    clickAllegati(arg) {
      this.input_args_allegati.id_riferimento = arg.id_commessa;
      this.allegati_visible = true;
    },
    addColumn() {
      this.items_impostazioni.push({
        id_header: -1,
        modulo: "LISTA_COMMESSA",
        text: "Nuova Colonna",
        value: "",
        fields: "",
        join_fields: "",
        visible: 1,
      });
    },
    chiudiAssociaModelli() {
      this.dialog_associa_modelli = false;
      this.key_windowframe = this.key_windowframe =
        this.key_windowframe === 0 ? 1 : 0;
    },
    handleClickChiudiAnalisi() {
      this.dialog_analisi_articolo = false;
    },
    duplicazioneMassiva() {
      let arr = [];
      arr = this.items.filter((item) => item.edit_stato == true);

      arr.forEach((e) => {
        this.duplicaCommessa(e);
      });
    },
    clickDuplica(item) {
      this.commessa_sel = item;
      this.dialog_conferma_duplicazione = true;
    },
    duplicaCommessa(item, no_duplicazione_moduli) {
      this.overlay = true;
      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessafull",
          token: localStorage.getItem("user_token"),
          id_commessa: item.id_commessa,
          id_profilo: localStorage.id_profilo,
          componenti_stessa_commessa: 1,
        },
      };

      this.$store
        .dispatch("api", richiesta)
        .then((res) => {
          var tempCommessa = res.data;

          tempCommessa.commessa.forEach((e) => {
            e.cod_commessa = null;
            e.id_commessa = -1;
            e.numero_commessa = null;
            e.data_commessa = moment().format("YYYY-MM-DD");
            /*let new_cod = e.cod_commessa.slice(1);
            new_cod = Number(new_cod) + 1;*/
            /*e.cod_commessa = "C" + new_cod;
            this.des_stato_list.forEach((i) => {
              if ("Creata" === i.des) {
                e.id_stato = i.id_tabella;
              }
            });*/
          });
          tempCommessa.commessa_dettaglio.forEach((cd) => {
            cd.id_commessa = -1;
            cd.id_commessa_dettaglio = -1;

            if (cd.commessa_dettaglio_personale) {
              cd.commessa_dettaglio_personale.forEach((cdp) => {
                cdp.idciclo_fasi_personale = -1;
                cdp.id_commessa_dettaglio = -1;
              });
            }

            if (cd.commessa_dettaglio_macchina) {
              cd.commessa_dettaglio_macchina.forEach((cdm) => {
                cdm.idciclo_fasi_macchina = -1;
                cdm.id_commessa_dettaglio = -1;
              });
            }

            if (cd.commessa_dettaglio_fornitori) {
              cd.commessa_dettaglio_fornitori.forEach((cdf) => {
                cdf.idciclo_fasi_fornitori = -1;
                cdf.id_commessa_dettaglio = -1;
              });
            }

            if (cd.operazioni) {
              cd.operazioni.forEach((cdo) => {
                cdo.id_commessa_operazione = -1;
                cdo.id_commessa_dettaglio = -1;
              });
            }
          });
          tempCommessa.commessa_distinta.forEach((e) => {
            e.id_commessa = -1;
            e.id_commessa_distinta_base = -1;
          });

          let richiesta2 = {
            controller: "Magazzino",
            method: "PUT",
            richiesta: {
              action: "setcommessa",
              token: localStorage.getItem("user_token"),
              id_commessa: -1,
              id_profilo: localStorage.id_profilo,
              id_articolo: tempCommessa.commessa[0].id_articolo,
              tabella: [tempCommessa],
            },
          };
          this.$store.dispatch("api", richiesta2).then((res) => {
            this.overlay = false;

            if (no_duplicazione_moduli != null) {
              this.handleClick({ id_commessa: res.data.result });
            } else {
              this.getCommessa();
              this.$refs.SnackbarQV.print("success", "Commessa Duplicata");
              this.duplicaAssociazioneModLog(item, res.data.result);
            }
          });
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    duplicaAssociazioneModLog(item, id_commessa_copy) {
      this.overlay = true;
      let richiesta = {
        controller: "Magazzino",
        method: "put",
        richiesta: {
          action: "copycommessamodello",
          token: localStorage.getItem("user_token"),
          id_commessa: item.id_commessa,
          id_commessa_copy: id_commessa_copy,
        },
      };

      this.$store
        .dispatch("api", richiesta)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    clickDialogAssociaModello(item) {
      this.input_args_modelli.id_commessa = item.id_commessa;
      this.dialog_associa_modelli = true;
    },
    analisiArticolo(id) {
      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessafull",
          token: localStorage.getItem("user_token"),
          id_commessa: id,
          id_profilo: localStorage.id_profilo,
          componenti_stessa_commessa: 1,
        },
      };
      this.overlay = true;
      this.$store
        .dispatch("api", richiesta)
        .then((res) => {
          this.overlay = false;
          this.input_args.id_articolo = res.data.commessa[0].id_articolo;
          this.key_analisi_generale = this.key_analisi_generale == 0 ? 1 : 0;
          this.dialog_analisi_articolo = true;
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione con il server"
          );
        });
    },
    async getTipiAvanzamento() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "TIPO_AVANZAMENTO_COMMESSA",
          filter: "validita = 1",
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          this.tipi_avanzamento = res.data;
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    async getColonne() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getheader",
          token: localStorage.getItem("user_token"),
          nome_modulo: "LISTA_COMMESSA",
          tipo2: "",
          filter: "validita = 1",
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          this.items_impostazioni = res.data;
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    changeFilter() {
      localStorage.setItem("commessa_filtro_stato", this.des_stato);
    },
    setDefaultDates() {
      var data_da_temp = new Date();
      var data_a_temp = new Date();
      if (data_da_temp.getMonth() < this.mesi_p) {
        data_da_temp.setMonth(data_da_temp.getMonth() - this.mesi_p + 12);
        data_da_temp.setFullYear(data_da_temp.getFullYear() - 1);
      } else {
        data_da_temp.setMonth(data_da_temp.getMonth() - this.mesi_p);
      }
      this.data_da =
        data_da_temp.getFullYear().toString() +
        "-" +
        (data_da_temp.getMonth() + 1).toString() +
        "-" +
        data_da_temp.getDate().toString();
      if (data_a_temp.getMonth() > 11 - this.mesi_f) {
        data_a_temp.setMonth(data_a_temp.getMonth() + this.mesi_f - 12);
        data_a_temp.setFullYear(data_a_temp.getFullYear() + 1);
      } else {
        data_a_temp.setMonth(data_a_temp.getMonth() + this.mesi_f);
      }
      this.data_a =
        data_a_temp.getFullYear().toString() +
        "-" +
        (data_a_temp.getMonth() + 1).toString() +
        "-" +
        data_a_temp.getDate().toString();
    },
    async saveImpostazioni() {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setimpostazionicommesse",
          impostazioni:
            this.tipo_avanzamento +
            "," +
            this.mesi_p +
            "," +
            this.mesi_f +
            "," +
            this.stato_def +
            "," +
            this.is_picking +
            "," +
            this.dashboard_sel +
            "," +
            this.tipo_ordinamento_date,
          token: localStorage.getItem("user_token"),
        },
      };
      await this.$store.dispatch("api", request).then((res) => {
        if (res.status != 200) {
          this.$refs.SnackbarQV.print("error", "Impostazioni non Salvati");
          return;
        }
      });
      let request2 = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setheader",
          header: this.items_impostazioni,
          token: localStorage.getItem("user_token"),
        },
      };
      await this.$store.dispatch("api", request2).then((res) => {
        if (res.status == 200) {
          this.$refs.SnackbarQV.print("success", "Impostazioni Salvati");
        } else {
          this.$refs.SnackbarQV.print("error", "Impostazioni non Salvati");
        }
        this.impostazioniDialog = false;
      });
    },

    setPersonaleCommessa() {
      this.overlay = true;

      this.commessa.commessa_dettaglio.forEach((f) => {
        const arr_profili_tmp = [];

        f.personale_new.forEach((p) => {
          if (p.id_utente) {
            const obj_tmp = {
              id_articolo: f.id_articolo,
              id_commessa_dettaglio: f.id_commessa_dettaglio,
              id_personale: p.id_utente,
              idciclo_fasi_personale: -1,
              nominativo: p.nominativo,
              validita: 1,
            };

            arr_profili_tmp.push(obj_tmp);
          } else {
            const obj_tmp = {
              id_articolo: f.id_articolo,
              id_commessa_dettaglio: f.id_commessa_dettaglio,
              id_personale: p.id_personale,
              idciclo_fasi_personale: -1,
              nominativo: p.nominativo,
              validita: 1,
            };

            arr_profili_tmp.push(obj_tmp);
          }
        });

        this.ciclo_lista_clone.forEach((f_o) => {
          if (f_o.id_commessa_dettaglio == f.id_commessa_dettaglio) {
            f_o.commessa_dettaglio_personale.forEach((p_o) => {
              let occorrenze = 0;
              arr_profili_tmp.forEach((p_n) => {
                if (p_o.id_personale == p_n.id_personale) {
                  p_n.idciclo_fasi_personale = p_o.idciclo_fasi_personale;
                  occorrenze = occorrenze + 1;
                }
              });

              if (occorrenze == 0) {
                const obj_tmp = {
                  id_articolo: f.id_articolo,
                  id_commessa_dettaglio: f.id_commessa_dettaglio,
                  id_personale: p_o.id_personale,
                  idciclo_fasi_personale: p_o.idciclo_fasi_personale,
                  nominativo: p_o.nominativo,
                  validita: 0,
                };

                arr_profili_tmp.push(obj_tmp);
              }
            });
          }
        });

        f.commessa_dettaglio_personale = arr_profili_tmp;
        delete f.personale_new;
      });

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessa",
          token: localStorage.getItem("user_token"),
          id_articolo: this.commessa.commessa[0].id_articolo,
          id_commessa: this.commessa.commessa[0].id_commessa,
          id_profilo: localStorage.id_profilo,
          tabella: [this.commessa],
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        if (res.status == 200) {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "success",
            "Personale salvato con successo."
          );
        } else {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione con il server."
          );
        }
        this.dialog_personale_fasi = false;
      });
    },
    async openImpostazioni() {
      await this.getTipiAvanzamento();
      await this.getColonne();
      this.impostazioniDialog = true;
    },
    // In order to go to dashboard
    gotoDashboard() {
      this.$router.push("/home/production");
    },
    // In order to go to new Commessa form
    GoToCommessa() {
      this.$router.push(`/home/production/commesa/-1`);
    },
    GoToCommessaMultipla() {
      this.$router.push(`/home/production/commessamultipla/-1`);
    },
    // in order to go to Commessa Detail
    handleClick(val) {
      if (this.search_confirmed != "" && this.search_confirmed != null) {
        localStorage.commessa_filtro_parziale = this.search_confirmed;
      }

      if (this.data_da != "" && this.data_da != null) {
        localStorage.commessa_filtro_data_da = this.data_da;
      }

      if (this.data_a != "" && this.data_a != null) {
        localStorage.commessa_filtro_data_a = this.data_a;
      }

      this.$router.push(`/home/production/commesa/${val.id_commessa}`);
    },
    // In order to get commessa Lista
    getCommessa() {
      this.overlay = true;
      /* Riporto a false la variabile "cambia_stato_sel",
       * in caso l'utente l'avesse modificata, per ripristinare
       * lo stato originale. */
      this.cambia_stato_sel = false;
      // var des_stato = "";
      if (this.cambia_stato_sel == true) {
        this.cambia_stato_sel = false;
      }
      this.des_stato_list.map((it) => {
        if (this.des_stato === it.des) {
          this.id_stato = it.id_tabella;
        }
      });
      let getcommessa = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessa",
          data_da: this.data_da,
          data_a: this.data_a,
          id_profilo: localStorage.getItem("id_profilo"),
          token: localStorage.getItem("user_token"),
          id_commessa: "",
          id_articolo: "",
          id_stato: this.des_stato === "" ? null : this.id_stato,
          tipo_ordinamento_date:
            this.tipo_ordinamento_date == null ||
            this.tipo_ordinamento_date == ""
              ? 0
              : this.tipo_ordinamento_date,
          filtri: "",
        },
      };

      return this.$store
        .dispatch("api", getcommessa)
        .then((res) => {
          if (res.status === 200) {
            this.overlay = false;
            this.items = res.data.lista;

            if (res.data.header != undefined) {
              this.headers = res.data.header;
            }
            /* Se l'utente vuole modificare lo stato delle
             * commesse, aggiungo una colonna edit_stato. */
            if (this.cambia_stato_sel === true) {
              let edit_stato = {
                value: "edit_stato",
                sortable: false,
                text: "Selezione",
                visible: 1,
              };
              this.headers.unshift(edit_stato);
            }
            this.items.map((it) => (it.delete = ""));
            this.items.map((it) => (it.edit = ""));
            this.items.map((it) => (it.edit_stato = false));
            if (this.items.length > 0) {
              this.show = false;
            }
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server nel caricamento delle commesse."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server nel caricamento delle commesse."
          );
          return false;
        });
    },
    getCicloFasi(arg) {
      this.overlay = true;
      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessafull",
          token: localStorage.getItem("user_token"),
          id_commessa: arg.id_commessa,
          id_profilo: localStorage.id_profilo,
          componenti_stessa_commessa: 1,
        },
      };
      this.$store.dispatch("api", richiesta).then((res) => {
        this.commessa = res.data;
        this.ciclo_lista = res.data.commessa_dettaglio;
        this.ciclo_lista_clone = JSON.parse(
          JSON.stringify(res.data.commessa_dettaglio)
        );
        this.ciclo_lista.forEach((e) => {
          e.personale_new = [];
          if (e.commessa_dettaglio_personale.length > 0) {
            e.commessa_dettaglio_personale.forEach((p) => {
              let obj_personale = {
                id_utente: p.id_personale,
                nominativo: p.nominativo,
              };
              e.personale_new.push(obj_personale);
            });
          }
        });
      });
      this.overlay = false;
    },
    getPersonale() {
      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getutenti",
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("api", richiesta).then((res) => {
        this.personale_list = res.data;
      });
    },
    selectAll() {
      this.items.forEach((e) => {
        if (
          this.items_displayed.includes(e.id_commessa) ||
          !this.selectAllBool
        ) {
          e.edit_stato = this.selectAllBool;
        }
      });
      this.selectAllBool = !this.selectAllBool;
    },
    makePicking() {
      if (this.items.filter((e) => e.edit_stato === true).length === 0) {
        this.$refs.SnackbarQV.print("orange", "Selezionare almeno un elemento");
        return;
      } else {
        this.overlay = true;
        this.cambia_stato_sel = false;
        const request = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "setpickingcommessa",
            token: localStorage.getItem("user_token"),
            commesse: this.items.filter(
              (e) =>
                e.edit_stato == true && (e.picking == null || e.picking == "")
            ),
          },
        };

        this.$store.dispatch("api", request).then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Picking creato");
          } else {
            this.$refs.SnackbarQV.print("error", "Picking non creato");
          }
          this.overlay = false;
          this.getCommessa();
        });
      }
    },
    clickModificaStatoCommessa() {
      // Controllo che ci siano oggetti selezionati
      if (this.items.filter((e) => e.edit_stato === true).length === 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare almeno un elemento da modificare."
        );
        return;
      }

      /* Controllo che lo stato di partenza e di
       * arrivo non corrispondano. Per lo stato di
       * partenza guardo lo stato del primo oggetto
       * nell'array (tanto sono tutti uguali). */
      if (this.items[0].id_stato === this.stato_sel) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il nuovo stato deve essere diverso da quello attuale."
        );
        return;
      }

      /* Se sto modificando gli stati da aperto a whatever
       * chiedo al BE se ci sono WO in esecuzione per qualcuna
       * delle commesse che voglio modificare. */
      if (this.items[0].id_stato === this.id_stato_aperto) {
        // Mi metto da parte gli id delle commesse da modificare.
        let tabella = [];
        this.items.forEach((elem) => {
          if (elem.edit_stato == true) {
            tabella.push(elem.id_commessa);
          }
        });

        // Preparo la request
        const request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "checkwocommessaattivi",
            token: localStorage.user_token,
            tabella: tabella,
            id_stato: this.stato_sel,
          },
        };

        /* Chiedo al BE se le commesse da modificare sono libere.
         * Se mi risponde true faccio la chiamata per modificare,
         * altrimenti stampo un dialog di conferma all'utente.*/
        this.$store.dispatch("api", request).then((res) => {
          if (res.status === 200) {
            if (res.data.response == true) {
              this.modificaStatoCommessa();
            } else {
              this.items_commesse_aperte = new Array();
              res.data.result.forEach((e) => {
                this.items_commesse_aperte.push(Object.assign(e));
              });

              this.dialog_impegni = true;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        });
      } else {
        /* Altrimenti sto cambiando lo stato in aperto
         * e posso fare la chiamata normalmente senza
         * controllare eventuali attività.*/
        this.modificaStatoCommessa();
      }
    },
    clickPersonale(item) {
      this.getCicloFasi(item);
      this.getPersonale();
      this.dialog_personale_fasi = true;
    },
    closeDialogCicli() {
      this.ciclo_lista = [];
      this.dialog_personale_fasi = false;
    },
    modificaStatoCommessa() {
      /* Se l'utente non ha selezionato uno stato
       * stampo una snackbar di errore. */
      this.overlay = true;
      if (this.stato_sel == null) {
        this.snackbar = true;
        this.snackbar_background = "orange";
        this.snackbar_font_size = 40 + "px";
        this.snackbar_text = "Selezionare uno stato.";
        this.overlay = false;
      } else {
        let tabella = [];
        this.items.forEach((elem) => {
          if (elem.edit_stato == true) {
            elem.edit_stato = false;
            elem.des_stato = this.stato_sel;
            tabella.push(elem.id_commessa);
          }
        });
        let request = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "setcommessestato",
            token: localStorage.getItem("user_token"),
            tabella: tabella,
            id_tabella: this.stato_sel,
          },
        };
        this.$store.dispatch("api", request).then(() => {
          this.overlay = false;
          // Disabilito la modifica multipla di stato e svuoto gli headers.
          this.cambia_stato_sel = false;
          this.headers = [];
          // Aggiorno la tabella; questa azione ripopola gli headers.
          this.getCommessa();
        });
      }
    },
    selezionaSquadra(arg) {
      this.fase_sel = JSON.parse(JSON.stringify(arg));

      this.sede_sel = null;
      this.reparto_sel = null;
      this.squadra_sel = null;
      this.items_operatori_squadra = new Array();

      /* Precompilo il form con la prima sede e
       * il primo reparto disponibili. Questo
       * fa scattare il caricamento delle squadre,
       * e anche per quelle ci sarà la precompilazione
       * eventuale con la prima squadra disponibile. */
      if (this.items_sedi_squadra.length > 0) {
        this.sede_sel = this.items_sedi_squadra[0].id_azienda_sede;

        if (this.items_reparti_squadra.length > 0) {
          this.reparto_sel = this.items_reparti_squadra.filter(
            (e) => e.id_azienda_sede == this.sede_sel
          )[0].id_azienda_sede_reparto;
        }
      }

      this.dialog_selezione_squadra = true;
    },
    confermaSelezioneSquadra() {
      // Prendo da parte la fase che ho selezionato.
      const f = this.ciclo_lista.filter(
        (f) => f.id_commessa_dettaglio == this.fase_sel.id_commessa_dettaglio
      )[0];

      /* Per ogni operatore della squadra, se è stato selezionato
       * e non ricorre ancora fra gli operatori della fase, lo
       * aggiungo agli operatori della fase selezionata. */
      this.items_operatori_squadra.forEach((o) => {
        if (
          o.selezionato === true &&
          f.personale_new.filter((p) => p.id_utente === o.id_utente).length == 0
        ) {
          f.personale_new.push({
            id_utente: o.id_utente,
            nominativo: `${o.nome} ${o.cognome}`,
          });
        }
      });

      /* Tolgo dal personale della fase gli
       * operatori che non sono flaggati. */
      this.items_operatori_squadra
        .filter((o) => o.selezionato === false)
        .forEach((o) => {
          f.personale_new = f.personale_new.filter(
            (e) => e.id_utente != o.id_utente
          );
        });

      this.dialog_selezione_squadra = false;
    },
    async getSedi() {
      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getaziendasedi",
          id_azienda: 1,
          id_azienda_sede: null,
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_sedi_squadra = res.data ? res.data : [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    getReparti() {
      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getaziendasedereparti",
          id_azienda: 1,
          id_azienda_sede: null,
          id_azienda_sede_reparto: null,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.items_reparti_squadra = res.data;
      });
    },
    getSquadre() {
      let request = {
        controller: "magazzino",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getsquadre",
          id_reparto: this.reparto_sel,
        },
      };

      this.overlay = true;

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_squadre = res.data.result.squadre;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
          return false;
        });
    },
  },
  async mounted() {
    this.getAssociazioniTipiReport();
    this.GetDashboard();

    await this.getStatiCommessa();

    /* Prendo le impostazioni del modulo per sapere
     * i criteri con cui cercare le commesse. */
    let request = {
      controller: "Magazzino",
      method: "POST",
      richiesta: {
        action: "getimpostazionicommesse",
        token: localStorage.getItem("user_token"),
      },
    };

    await this.$store.dispatch("api", request).then((res) => {
      if (res.data.result.impostazioni[0].note != null) {
        var tempImpo = res.data.result.impostazioni[0].note;
        this.tipo_avanzamento = parseInt(tempImpo.split(",")[0]);
        this.mesi_p = parseInt(tempImpo.split(",")[1]);
        this.mesi_f = parseInt(tempImpo.split(",")[2]);
        this.stato_def = parseInt(tempImpo.split(",")[3]);
        this.is_picking = tempImpo.split(",")[4];
        this.dashboard_sel = tempImpo.split(",")[5];
        this.tipo_ordinamento_date = tempImpo.split(",")[6]
          ? parseInt(tempImpo.split(",")[6])
          : 0;
        this.setDefaultDates();
      }
    });

    /* Se c'è nel localstorage un filtro
     * sullo stato commessa, lo uso e lo annullo. */
    if (
      localStorage.getItem("commessa_filtro_stato") != null &&
      localStorage.getItem("commessa_filtro_stato") != "null" &&
      localStorage.getItem("commessa_filtro_stato") != ""
    ) {
      this.des_stato = localStorage.getItem("commessa_filtro_stato");
    }

    /* Se c'è nel localstorage un filtro
     * sulla "data da", lo uso e lo annullo. */
    if (
      localStorage.getItem("commessa_filtro_data_da") != null &&
      localStorage.getItem("commessa_filtro_data_da") != "null" &&
      localStorage.getItem("commessa_filtro_data_da") != ""
    ) {
      this.data_da = localStorage.getItem("commessa_filtro_data_da");
      delete localStorage.getItem("commessa_filtro_data_da");
    }

    /* Se c'è nel localstorage un filtro
     * sulla "data a", lo uso e lo annullo. */
    if (
      localStorage.getItem("commessa_filtro_data_a") != null &&
      localStorage.getItem("commessa_filtro_data_a") != "null" &&
      localStorage.getItem("commessa_filtro_data_a") != ""
    ) {
      this.data_a = localStorage.getItem("commessa_filtro_data_a");
      delete localStorage.getItem("commessa_filtro_data_a");
    }

    // Cerco le commesse.
    await this.getCommessa();

    /* Se c'è nel localstorage un filtro
     * parziale salvato, lo uso e lo annullo. */
    if (
      localStorage.commessa_filtro_parziale != null &&
      localStorage.commessa_filtro_parziale != ""
    ) {
      this.search = localStorage.commessa_filtro_parziale;
      this.confirmSearch();
      delete localStorage.commessa_filtro_parziale;
    } else {
      this.confirmSearch();
    }

    /* Se l'utente ha il pulsante delle sedi, faccio
     * anche la chiamata per avere sedi e reparti. */
    if (this.headers.filter((elem) => elem.value == "personale").length > 0) {
      await this.getSedi();
      this.getReparti();
    }
  },
  computed: {
    formatDate() {
      return this.data_da ? moment(this.data_da).format("DD/MM/YYYY") : "";
    },
    formatDaAa() {
      return this.data_a ? moment(this.data_a).format("DD/MM/YYYY") : "";
    },
  },
  watch: {
    reparto_sel: {
      immediate: true,
      async handler() {
        if (this.reparto_sel != null) {
          await this.getSquadre();

          /* Quando seleziono un reparto precompilo
           * con la prima squadra disponibile. */
          if (this.items_squadre.length > 0) {
            this.squadra_sel = this.items_squadre[0].id_squadra;
          }
        }
      },
    },
    squadra_sel: {
      immediate: true,
      handler() {
        if (this.squadra_sel != null) {
          this.items_operatori_squadra = new Array();
          this.items_squadre.forEach((s) => {
            if (s.id_squadra == this.squadra_sel) {
              const arr_tmp = JSON.parse(JSON.stringify(s.persone));

              /* Aggiungo il personale; se il personale era già
               * presente lo segno come flaggato, altrimenti no. */
              arr_tmp.forEach((p) => {
                p.selezionato =
                  this.fase_sel.personale_new.filter(
                    (elem) => elem.id_utente == p.id_utente
                  ).length > 0
                    ? true
                    : false;
              });

              this.items_operatori_squadra = arr_tmp;
            }
          });
        }
      },
    },
    cambia_stato_sel: {
      immediate: true,
      handler() {
        // Se l'elenco commesse è vuoto, non faccio niente.
        if (this.items.length === 0) {
          return;
        }
        /* Se l'utente vuole modificare lo stato delle
         * commesse, aggiungo una colonna edit_stato. */
        if (this.cambia_stato_sel === true) {
          let edit_stato = {
            value: "edit_stato",
            sortable: false,
            text: "Selezione",
            visible: 1,
          };
          this.headers.unshift(edit_stato);
          /* Elimino l'header per la modifica */
          let headers_tmp = this.headers.filter((elem) => elem.value != "edit");
          this.headers = [];
          this.headers = headers_tmp;
          /* Elimino l'header per la cancellazione */
          headers_tmp = [];
          headers_tmp = this.headers.filter((elem) => elem.value != "delete");
          this.headers = [];
          this.headers = headers_tmp;
        } else {
          /* Se invece l'utente non vuole modificare lo
           * stato delle commesse, rimuovo la colonna relativa. */
          let headers_tmp = this.headers.filter(
            (elem) => elem.value != "edit_stato" && elem.value != "edit"
          );
          this.headers = [];
          this.headers = headers_tmp;
          /* Aggiungo l'header per la modifica. */
          let edit = {
            value: "edit",
            sortable: false,
            text: "Modifica",
            visible: 1,
          };
          this.headers.unshift(edit);
          /* Aggiungo l'header per la cancellazione. */
          let del = {
            value: "delete",
            sortable: false,
          };
          this.headers.push(del);
        }
      },
    },
  },
};
</script>
